// Prices from the store API are integer cents; attribute value prices are deltas on top of the product base.
export const formatPrice = (cents) => {
    const amount = Number(cents ?? 0) / 100;

    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const formatPriceDelta = (cents) => {
    const amount = Number(cents ?? 0);

    if (amount === 0) {
        return '';
    }

    return `${amount > 0 ? '+' : '-'}${formatPrice(Math.abs(amount))}`;
};

export const formatDuration = (minutes) => {
    const total = Math.max(0, Math.round(Number(minutes ?? 0)));
    const hours = Math.floor(total / 60);
    const remainder = total % 60;

    if (hours === 0) {
        return `${remainder} min`;
    }

    return remainder === 0 ? `${hours} hr` : `${hours} hr ${remainder} min`;
};

export const formatDurationDelta = (minutes) => {
    const total = Math.round(Number(minutes ?? 0));

    if (total === 0) {
        return '';
    }

    return `${total > 0 ? '+' : '-'}${formatDuration(Math.abs(total))}`;
};

export const describeAttributeValue = (value) => {
    const parts = [formatPriceDelta(value?.price), formatDurationDelta(value?.duration)].filter(Boolean);

    return parts.length === 0 ? 'Included' : parts.join(' · ');
};
